/* eslint-disable max-len */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState } from 'react'
import CardHeader from '../../../../../components/CardHeader'
import UpdateButton from '../../../../../components/UpdateButton'
import { useNavigate, useParams } from 'react-router-dom'
import StudentData from './Componets/StudentData'
import Invoice from './Componets/Invoices'
import Amounts from './Componets/Amounts'
import Toast from "../../../../../components/Toast"
import { dataService } from '../../../../../services/data.services'
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId'
import CustomOverLay from '../../../../../components/CustomOverlay'
import moment from 'moment'
import AnimatedModel from '../../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt'
import GlobalContext from '../../../../../components/Context/GloablContext'
import { useSelector } from 'react-redux'
import { CognitoData } from '../../../../../CommonMethods/CognitoData';
import { use } from 'react'

export default function CollectFeeInvoice() {
    const {setToastmessage, setStudentCollectFee, setToastErrorMessage, reloadFY, setReloadFY, studentIdCollectFee, rolesGlobal} = useContext(GlobalContext);
    const [state, setState] = useState({})
    const [receivedAmount, setReceivedAmount] = useState(0)
    const [oldState, setOldState] = useState({})
    const [loading, setLoading] = useState(true);
    const [submitSelected, setsubmitSelected] = useState(false)
    const [toastMessage, setErrorMessage] = useState("")
    const [handleFieldError, setHandleFieldError] = useState("")
    const [dateError, setdateError] = useState("");
    const [descriptionCount, setDescriptionCount] = useState(null)
    const {id} = useParams();
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const navigate = useNavigate()
    const [loadingButton, setLoadingButton] = useState(false)
    const [errorIndex, setErrorIndex] = useState(null)
    const [appliedError, setAppliedError] = useState(false);
    const {userType} = useSelector((state)=>state.auth);
    const [showDropdown, setshowDropdown] = useState({});
    const GlobalChange=useSelector(state=>state.GlobalData)
    const [receiptTypes, setReceiptTypes] = useState([]);

    /**
     * The function `getViewInvoice` is an asynchronous function that retrieves an invoice from an API,
     * modifies the data, and updates the state with the modified data.
     */
    const getViewInvoice = async () => {
        try {
            // Get the current date
            const currentDate = moment();
            // Format the date if needed
            let formattedDate = '';
            const fy = JSON.parse(localStorage.getItem('FY_details'));
            const fy_start_date = new Date(fy.start_date);
            const fy_end_date = new Date(fy.end_date);
            if ((currentDate >= fy_start_date && currentDate <= fy_end_date)) {
                formattedDate = currentDate.format('MMM DD,YYYY');
            }

            const branch_id = await GetBranchId()
            const invoice = await dataService.GetAPI(`collect-fees/${branch_id}/${id}`);
            const data = invoice.data.data
            if(data?.invoices?.length === 0) {
                setStudentCollectFee("")
                navigate("/404");
            } else {
                data["financial_year"] = `${fy.name} (${fy.status.charAt(0).toUpperCase() + fy.status.slice(1)})`
                data["applied_amount"] = 0
                data["received_amount"] = "0.00"
                data["received_date"] = formattedDate
                setState(data)
                setOldState(data)
                setLoading(false)
                setStudentCollectFee(id)
            }
        } catch(error) {
            console.log("error", error)
            if(error?.response?.data?.message?.includes("is already in progress")) {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
                navigate(-1)
            } else {
                setErrorMessage(error.response.data.message)
                navigate('/404')
            }
        }
    }
    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, it
    is used to fetch the invoice data when the component mounts. */
    useEffect(() => {
        setLoading(true)
        getViewInvoice()
        setReloadFY(false)
    }, [reloadFY])

    useEffect(() => {
        const fetchUser = async () => {
            const user = await CognitoData();
            let roles = rolesGlobal || user.idToken.payload["cognito:groups"];
            
            if (user.idToken.payload['custom:user_type'] !== "institution-admin") {
                console.log('insidenot admin')
                // Set receiptTypes based on roles
                const allowedTypes = [];
                const anyCollectFeeRoleExists = roles.some(role => role.startsWith('collect-fee'));
                if ((roles.includes('collect-fee') && !anyCollectFeeRoleExists) || 
                    (roles.includes('collect-fee') && roles.includes('collect-fee:receipt'))) {
                    allowedTypes.push('Receipt');
                }
                if (roles.includes('collect-fee:-rte')) {
                    allowedTypes.push('RTE');
                }
                if (roles.includes('collect-fee:scholarship')) {
                    allowedTypes.push('Scholarship');
                }
                if (roles.includes('collect-fee:discount')) {
                    allowedTypes.push('Discount');
                }
                if (roles.includes('collect-fee:write-off')) {
                    allowedTypes.push('Write-off');
                }
                console.log("allowedTypes", allowedTypes)
                setReceiptTypes(allowedTypes);
            }
            else{
                const receiptTypes = ['Receipt', 'RTE', 'Scholarship', 'Discount', 'Write-off'];
                setReceiptTypes(receiptTypes);
            }
        };
        fetchUser();
    }, [GlobalChange])

    
    /**
     * The handleInput function is used to handle input changes and validate the received_amount field
     * in a React component.
     */
    const handleInput = (e) => {
        let { id, value } = e.target;
        setErrorMessage("")
        setsubmitSelected(false)
        setAppliedError(false);
        switch (id) {
        case "received_amount":
            value = value.trim()
            if (value?.length <= 13 ) {
                // Allow only up to 2 decimal places
                const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
                if (regex.test(value)) {
                    setReceivedAmount(value)
                    let receivedAmount = parseFloat(value).toFixed(2);
                    let remainingAmount = receivedAmount;
                    let dueAmount = 0;
                    let totalAppliedAmount = 0;
                    let totalReceivedAmount = receivedAmount;

                    const updatedInvoices = state.invoices.map((invoice, idx = 0) => {
                        let applyAmountLineItem = 0;
                        return {
                            ...invoice,
                            items: invoice.items.map((item, item_index = 0) => {
                                if (invoice.is_selected) {
                                    const balanceAmount = oldState.invoices[idx].items[item_index].balance_line_amount;
                                    // if (remainingAmount > 0 && balanceAmount > 0 ) {
                                    dueAmount += balanceAmount - Math.min(remainingAmount, balanceAmount);
                                    receivedAmount += Math.min(remainingAmount, balanceAmount);
                                    const amountToApply = Math.min(remainingAmount, balanceAmount);
                                    remainingAmount -= amountToApply;
                                    totalAppliedAmount += amountToApply;
                                    applyAmountLineItem += amountToApply;
                                    return {
                                        ...item,
                                        received_line_amount: parseFloat(amountToApply),
                                        balance_line_amount: parseFloat((balanceAmount - amountToApply)),
                                    };
                                    // }
                                }
                                return item;
                            }),
                            due_amount: invoice.is_selected ? parseFloat(dueAmount) : oldState.invoices[idx].due_amount,
                            received_amount: invoice.is_selected ? parseFloat(applyAmountLineItem) : oldState.invoices[idx].received_amount,
                        };
                    });

                    setState((prevState) => ({
                        ...prevState,
                        invoices: updatedInvoices,
                        applied_amount: parseFloat(totalAppliedAmount),
                        remaining_amount: parseFloat((totalReceivedAmount - totalAppliedAmount)),
                    }));

                    setState((prev) => ({
                        ...prev,
                        [id]: value,
                    }));
                } 
                if(value === "") {
                    const updatedInvoices = state.invoices.map((invoice, idx = 0) => {
                        return {
                            ...invoice,
                            items: invoice.items.map((item, item_index = 0) => {
                                if(invoice.is_selected) {
                                    return {
                                        ...item,
                                        received_line_amount: oldState.invoices[idx].items[item_index].received_line_amount ,
                                        balance_line_amount:oldState.invoices[idx].items[item_index].balance_line_amount ,
                                    };
                                }
                                
                                return item;
                            }),
                            due_amount : oldState.invoices[idx].due_amount,
                            received_amount : oldState.invoices[idx].received_amount 
                        };
                    });
                    setState((prev) => ({
                        ...prev,
                        invoices: updatedInvoices,
                        applied_amount: 0,
                        remaining_amount : 0.00
                    }));
                }
            }
            break;
        case "reference_number":
            setState((prev) => ({
                ...prev,
                [id]: value,
            }));
            break;
        case "note":
            const words = value.trim().split(/\s+/);
            const currentWordCount = words?.length;
            setDescriptionCount(currentWordCount)
            if (currentWordCount <= 100) {
                setState((prv)=>({
                    ...prv,
                    [id]:value
                }))
            } else {
                setErrorMessage("Note cannot exceed 100 words")
            }
            break;

        default:
            break;
        }
    };

    /**
     * The function `handleSelectedDate` checks if a selected date is within a specified range and
     * updates the state accordingly, while also handling error cases.
     */
    const handleSelectedDate = (id, date, dateString) => {
        setHandleFieldError("")
        setAppliedError(false)
        setsubmitSelected(false)
        setErrorMessage("")
        // Parse the selected date string
        const selectedDate = moment.utc(dateString); // Parse as UTC
        const startDate = moment.utc(JSON.parse(localStorage.getItem('FY_details')).start_date); // Parse as UTC
        let endDate = moment.utc().startOf('day'); // Set to the start of today in UTC
        // Parse the start_date string
        if (selectedDate.isSameOrAfter(startDate) && selectedDate.isSameOrBefore(endDate)) {
            // The selected date is after or equal to the start date, so update the state
            setState((prev) => ({
                ...prev,
                [id]: dateString,
            }));
        } else {
            // The selected date is before the start date, so throw an error
            setHandleFieldError(id)
            setState((prev) => ({
                ...prev,
                [id]: "",
            }));
            setErrorMessage(`Collection Date must be within ${`${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`}`);
            // You can also set an error message in the state if needed.
        }
    };

    /**
     * The function `handleDropDownValue` updates the state fields based on the selected dropdown value
     * and handles error messages if the item code already exists.
     * @returns The function does not explicitly return anything.
     */

    const handleDropDownValue = (key, value) => {
        setState((prv) => ({
            ...prv,
            ...(key === "ledger_name"
                ? {
                    ledger_id: value?._id,
                    ledger_name: value?.parent_group_name_composite_key
                }
                : {
                    [key]: value,
                }
            )
        }));
        handleDropdown(key);
    };

    
    /**
    * The function `handleDropdown` toggles the visibility of a dropdown menu and resets some state
    * variables.
    */
    const handleDropdown = (key) => {
        setErrorMessage('')
        setsubmitSelected(false);
        setshowDropdown((prv) => ({
            ...prv,
            [key]: !showDropdown[key],
        }));
    };



    const handleValidation = () => {
        let count = 0
        const mandatoryArray = ["received_amount", "ledger_name", "received_date"]
        mandatoryArray.map((state_item) => {
            if(mandatoryArray.includes(state_item)){
                switch (state_item) {
                case "received_amount":
                case "ledger_name" : 
                case "received_date" :
                // case "reference_number":
                // case "note" :
                    if(state[state_item] === "" || state[state_item] === undefined) {
                        count++;
                    }
                    break;
                    
                default:
                    break;
                }
            }
       
        })
        return count !== 0
    }

    /**
     * The function `handelOpenFY` sets the `activateButtonLoading` state to `false` and the
     * `openConfirmation` state to `true`.
     */
    const handelOpenFY = async() => {
        setActivateButtonLoading(false)
        setOpenConfirmation(true)
    }
    const getRemainingAmount = () => {
        const appliedAmount = state.invoices.reduce((sum, invoice) => (invoice.items.forEach(item => sum += item.received_line_amount), sum), 0).toFixed(2);
        const receivedAmount = isNaN(parseFloat(state.received_amount)) ? 0 : parseFloat(state.received_amount);
        const remainingAmount = Math.max(receivedAmount - appliedAmount, 0).toFixed(2);
        return remainingAmount;
    }
    const handleAppliedAmountValidation = () => {
        let data = state.invoices.filter((entry, index = 0) => (
            entry.is_selected === true && entry.due_amount !== oldState.invoices[index].due_amount
        ));
        let appliedAmount = 0
        data.forEach((entry) => {
            if (entry.items && Array.isArray(entry.items)) {
                entry.items.forEach((item) => {
                    appliedAmount += item.received_line_amount
                });
            }
        });
        return parseFloat(appliedAmount.toFixed(2)) !== parseFloat(state?.received_amount)
    }
    /**
     * The handleSubmit function is used to handle form submission in a React application, performing
     * various validations and making an API call to collect fees from a student.
     */
    const handleSubmit = async() => {
        setErrorMessage("")
        handleAppliedAmountValidation()
        setLoadingButton(true);
        setAppliedError(false);
        if(openConfirmation) {
            setActivateButtonLoading(true)
            setLoadingButton(false)
        } else {
            setLoadingButton(true);
        }
        if(handleValidation()) {
            setsubmitSelected(true);
            setLoadingButton(false);
            setOpenConfirmation(false)
            setActivateButtonLoading(false)
            setErrorMessage("Please fill in all the mandatory fields")
        } else if(state.received_amount === "0" || state.receivedAmount === "" || state.received_amount === 0 || parseFloat(state.received_amount) === 0) {
            setsubmitSelected(true);
            setAppliedError(true);
            setLoadingButton(false);
            setOpenConfirmation(false)
            setActivateButtonLoading(false)
            setErrorMessage("Collection amount must be greater than zero")
        }
        else if(state.collection_type === "" || state.collection_type === undefined) {
            setsubmitSelected(true);
            setLoadingButton(false);
            setOpenConfirmation(false)
            setActivateButtonLoading(false)
            setErrorMessage("Select Collection Type")
        }
        else if(handleAppliedAmountValidation()) {
            setsubmitSelected(true);
            setAppliedError(true);
            setLoadingButton(false);
            setOpenConfirmation(false)
            setActivateButtonLoading(false)
            setErrorMessage(`The Total Applied Amount should be equal to the Collection Amount`)
        }else {
            if(!(userType==='institution-user' || userType==='institution-admin')) {
                const branch_id = await GetBranchId()
                const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing&sort=status%2Basc`, true);
                if(res.data.data.ongoing !== JSON.parse(localStorage.getItem('FY_details')).name) {
                    setToastErrorMessage(`You are not authorized to make entry for the${JSON.parse(localStorage.getItem('FY_details')).name}. Please refresh the page.`)
                    return
                }
            }
            try {
                let data = JSON.parse(JSON.stringify(state.invoices))
                    .filter((entry, index = 0) => (
                        entry.is_selected === true && entry.due_amount !== oldState.invoices[index].due_amount
                    ));

                let appliedAmount = 0;

                data.forEach((entry) => {
                    entry['total_received_amount'] = entry['received_amount'];
                    entry['total_balance_amount'] = entry['due_amount'];
                    delete entry['invoice_total'];
                    delete entry["invoice_type"];
                    delete entry["status"];
                    delete entry["due_amount"];
                    delete entry["is_selected"];
                    delete entry["received_amount"];

                    // Check if the object has the 'items' key
                    if (entry.items && Array.isArray(entry.items)) {
                        entry.items.forEach((item) => {
                            // Remove the 'line_item' key
                            appliedAmount += item.received_line_amount
                            delete item.item_name;
                            item.line_amount_balance = item.balance_line_amount;
                            delete item.balance_line_amount;
                            item.line_amount_received = item.received_line_amount;
                            delete item.received_line_amount;
                            item.line_item_amount = item.total_line_amount;
                            delete item.total_line_amount;
                        });
                    }
                });

                
                const body = {
                    "student_id": state?.student_id, 
                    "student_uuid": id,
                    "student_name": state?.student_name,
                    "class_id": state?.class_id,
                    "class_name": state?.class_name,
                    "section_id": state?.section_id,
                    "section_name" : state?.section_name,
                    "branch_id": state?.branch_id,
                    "received_amount": state?.received_amount,
                    "received_date": state?.received_date,
                    "financial_year": JSON.parse(localStorage.getItem('FY_details')).name,
                    "academic_year": state.academic_year,
                    "academic_year_id": state.academic_year_id,
                    "note": state?.note === undefined ? "" : state?.note,
                    "ledger_name": state?.ledger_name,
                    "collection_type": state?.collection_type,
                    "ledger_id": state?.ledger_id,
                    "reference_number": state?.reference_number,
                    "total_applied_amount": parseFloat(appliedAmount),
                    "remaining_amount": 0.00,
                    "invoices": data
                }
                setStudentCollectFee("")
                let response = null
                response = await dataService.PostAPI(body, 'collect-fees');
                setOpenConfirmation(false)
                setActivateButtonLoading(false)
                navigate(-1)
                setToastmessage(response?.data?.data?.message)
                setLoadingButton(false);
            } catch (error) {
                // Handle the error here
                setOpenConfirmation(false);
                setLoadingButton(false);
                setActivateButtonLoading(false);
                setErrorMessage(error?.response?.data?.message || "Something Went wrong");
                console.error("An error occurred:", error);
                // You might want to set some state or handle the error in a way appropriate to your application
            }
            
        }
    }
    
    const handleCancel = () => {
        navigate(-1);
        //navigate("/student-master/collect-fee")
    }

    const disabledFutureDate = (current) => {
        // Disable dates that are after the current date
        return current && current > moment().endOf('day');
    };

    return (
        <CardHeader noPadding>
            <div class="mainDataCntnrTop shadow-s13" style={{position: "sticky", position: "-webkit-sticky"}}>
                <h5 class="pageHeader addclass">Collect Fee</h5>
                <div class="flex items-center">
                    <UpdateButton
                        ButtonName={"Cancel"}
                        // loading={false}
                        disabled={loadingButton}
                        handleOnCLick={() => {handleCancel()}}
                        classKey="cancl-btn"
                    />
                    <UpdateButton
                        loading={loadingButton}
                        ButtonName={"Approve"}
                        width={'106px'}
                        handleOnCLick={() => {( JSON.parse(localStorage.getItem('FY_details')).status === "open" )? handelOpenFY() : handleSubmit()}}
                        classKey={"actn-btn onboardInstitution"}
                    />
                </div>
                {toastMessage!=='' &&<Toast
                    message={toastMessage}
                    type="error"
                    setToastmessage={setErrorMessage} />}
            </div>
            {loading ?   
                <CustomOverLay 
                    Active 
                    text="Loading..." 
                    classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}
                />
                :
                <div className='mainDataCntnrPageDiv scrollBlue_thick'>
                    <div className='display'>
                        <StudentData 
                            setErrorMessage={setErrorMessage}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                            state={state}
                            setState={setState}
                            handleFieldError={handleFieldError}
                            setdateError={setdateError}
                            handleSelectedDate={handleSelectedDate}
                            handleDropDownValue={handleDropDownValue}
                            handleDropdown={handleDropdown}
                            handleInput={handleInput}
                            descriptionCount={descriptionCount}
                            appliedError={appliedError}
                            disabledFutureDate={disabledFutureDate}
                            receiptTypes={receiptTypes}
                        />
                        <p className="text-xl bg-white left-0 right-0 z-40 font-semibold mb-2.5 mx-auto mt-[20px]">Invoices</p>
                        <div className=' mx-auto'>
                            <Invoice 
                                state={state}
                                setState={setState}
                                oldState={oldState}
                                setToastErrorMessage={setErrorMessage}
                                errorIndex={errorIndex}
                                setErrorIndex={setErrorIndex}
                                setAppliedError={setAppliedError}
                                mainReceivedAmount={receivedAmount}
                            />
                            <Amounts 
                                state={state}
                                getRemainingAmount={getRemainingAmount}
                            />
                        </div>
                    </div>
                </div>
                    
            }
            
            {openConfirmation && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleSubmit}
                        handleClose={() => setOpenConfirmation(false)}
                        crossMark
                        additionalMessage={`Collecting fee for '${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})', which appears to be a back-dated entry.`}
                        message = {`Do you want to continue?`}
                        buttonName = {`Continue`}
                        loadingActivation={activateButtonLoading}
                        tittle={'Back Dated Entry'}
                        dialogueWidth={'500px'}
                        textPosition={'text-start'}
                        
                    />
                }
            />  
            }
        </CardHeader>
    )
}
